// extracted by mini-css-extract-plugin
module.exports = {"slideInHam":"ChatWindow_slideInHam___SVII","slideOutHam":"ChatWindow_slideOutHam__3ylj2"};